import type { ReactNode } from 'react';

export const symbol_pregnancy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M411-110v-150h-61q-12.75 0-21.37-8.63Q320-277.25 320-290v-284q0-50 28-78t77.5-28q49.5 0 76 33t26.5 73q52 6 82 41.5t30 89.5v153q0 12.75-8.62 21.37Q622.75-260 610-260H485v150q0 12.75-8.62 21.37Q467.75-80 455-80h-14q-12.75 0-21.37-8.63Q411-97.25 411-110Zm-36.5-645.42q-21.5-21.42-21.5-51.5t21.42-51.58q21.42-21.5 51.5-21.5t51.58 21.42q21.5 21.42 21.5 51.5t-21.42 51.58q-21.42 21.5-51.5 21.5t-51.58-21.42Z"
		/>
	</svg>
);
